import Masonry from "masonry-layout"

addEventListener("report:remove", ({ detail }) => {
  const reports = detail.split(",").map(id => `#report-${id}`).join(", ")
  let msnry = Masonry.data("#admin-reports")

  msnry.remove(document.querySelectorAll(reports))
  msnry.layout()
})
